// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GrowthProfiles_GrowthProfileFragment = { __typename?: 'GrowthProfile', id: string, displayName: string, isDefault: boolean };

export type GrowthProfilesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.GrowthProfileWhereInput>;
}>;


export type GrowthProfilesQuery = { __typename?: 'Query', growthProfiles: { __typename?: 'GrowthProfileConnection', edges?: Array<{ __typename?: 'GrowthProfileEdge', node?: (
        { __typename?: 'GrowthProfile' }
        & GrowthProfiles_GrowthProfileFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GrowthProfiles: 'GrowthProfiles' as const
  },
  Fragment: {
    GrowthProfiles_GrowthProfile: 'GrowthProfiles_GrowthProfile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GrowthProfiles_GrowthProfileFragmentDoc = gql`
    fragment GrowthProfiles_GrowthProfile on GrowthProfile {
  id
  displayName
  isDefault
}
    `;
export const GrowthProfilesDocument = gql`
    query GrowthProfiles($where: GrowthProfileWhereInput) {
  growthProfiles(where: $where) {
    edges {
      node {
        ...GrowthProfiles_GrowthProfile
      }
    }
  }
}
    ${GrowthProfiles_GrowthProfileFragmentDoc}`;

/**
 * __useGrowthProfilesQuery__
 *
 * To run a query within a React component, call `useGrowthProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowthProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowthProfilesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGrowthProfilesQuery(baseOptions?: Apollo.QueryHookOptions<GrowthProfilesQuery, GrowthProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrowthProfilesQuery, GrowthProfilesQueryVariables>(GrowthProfilesDocument, withFetchPolicyContext(options));
      }
export function useGrowthProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrowthProfilesQuery, GrowthProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrowthProfilesQuery, GrowthProfilesQueryVariables>(GrowthProfilesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGrowthProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GrowthProfilesQuery, GrowthProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GrowthProfilesQuery, GrowthProfilesQueryVariables>(GrowthProfilesDocument, withFetchPolicyContext(options));
        }
export type GrowthProfilesQueryHookResult = ReturnType<typeof useGrowthProfilesQuery>;
export type GrowthProfilesLazyQueryHookResult = ReturnType<typeof useGrowthProfilesLazyQuery>;
export type GrowthProfilesSuspenseQueryHookResult = ReturnType<typeof useGrowthProfilesSuspenseQuery>;
export type GrowthProfilesQueryResult = Apollo.QueryResult<GrowthProfilesQuery, GrowthProfilesQueryVariables>;